import { getAllLayers } from 'pxc-editor-core/helpers/schema';
import Section from "pxc-editor-core/entities/Section";
import getSelectedSection from './getSelectedSection';

export default (payload) => {
  const {
    pages,
    sectionsSelection,
    isMatrix,
    textTypingResource
  } = payload;
  const selectedSectionIds = Object.keys(sectionsSelection);
  const isOneSectionSelected = selectedSectionIds.length === 1;
  const chosenSection = isOneSectionSelected ? getAllLayers(selectedSectionIds[0], pages)?.section : null;
  const selectedSections = Object.values(sectionsSelection);

  if (!!textTypingResource) {
    return false;
  }
  if (isMatrix) {
    if (isOneSectionSelected) {
      const isSelectedSectionEmpty = Section.contentIsEmpty(chosenSection);
      return isSelectedSectionEmpty ? false : true;
    }
    return true;
  }
  if (!!selectedSections.length) {
    if (selectedSections.length === 1) {
      const selectedSection = getSelectedSection({ sectionsSelection, pages });
      if (selectedSection) {
        const isSelectedSectionEmpty = Section.contentIsEmpty(selectedSection);
        return isSelectedSectionEmpty ? false : true;
      }
    } else if (selectedSections.length > 1) {
      const isSelectedSectionsEmpty = Object.values(selectedSections).every(section => Section.contentIsEmpty(section));
      return isSelectedSectionsEmpty ? false : true;
    }
  }
  return false;
};
